import { useRouter } from 'next/router';

/**
 * Get the value of a Next.js dynamic route parameter.
 *
 * @example ```ts
 * // Inside pages/[id].tsx
 *
 * const id = useRouteParam('id');
 * // typeof id === 'string'
 * ```
 */
export function useRouteParam(param: string, defaultValue?: string) {
  const { query } = useRouter();

  const value = query?.[param] ?? defaultValue;

  if (typeof value !== 'string') {
    throw new Error(`This page requires a ${param} string parameter`);
  }

  return value;
}
